{
  "ApiKeys_AddMode": "You must create a user first before you can create an API key.",
  "ApiKeys_Add_New": "Add New API Key...",
  "ApiKeys_RevokeButton": "Revoke",
  "ApiKeys_RemoveButton": "Delete",
  "ApiKeys_TableHeader_Name": "Name",
  "ApiKeys_TableHeader_Expiry": "Expiry",
  "ApiKeys_TableHeader_Created": "Created",
  "ApiKeys_TableHeader_LastAccessed": "Last Accessed",
  "ApiKeys_TableHeader_Title": "API Keys",
  "ApiKeys_Validations_Required": "Required",
  "ApiKeys_Name_Validations_MaxLength": "Max Length is 50",
  "ApiKeys_Revoke_ConfirmMessage": "Are you sure you want to revoke this API key?",
  "ApiKeys_Revoke_Confirm": "Confirm",
  "ApiKeys_Revoke_Cancel": "Cancel",
  "ApiKeys_Indefinite": "Never",
  "ApiKeys_Expired": "Expired",
  "ApiKeys_Placeholder_Description": "Description",
  "ApiKeys_KeyDisplay_Title": "Access Token Created: \"{}\"",
  "ApiKeys_KeyDisplay_SubTitle": "Record this token somewhere secure, it can't be viewed or retrieved once you close this window or add another key",
  "ApiKeys_Copy_Success": "Copied to clipboard",
  "ApiKeys_Copy_Fail": "Failed to copy to clipboard",
  "ApiKeys_MaxAPIKeysReached": "You have reached the maximum number of API keys, please delete an existing key before you can create a new one.",
  "NAME": "ApiKeys"
}